(function () {
  const tag = document.querySelector("[data-post-id]");
  if (tag) {
    const postId = tag.getAttribute("data-post-id");
    if (!localStorage.getItem(postId)) {
      localStorage.setItem(postId, "1");
      const body = new FormData();
      body.append("action", "oog_popular_count");
      body.append("post_id", postId);
      fetch("/wp-admin/admin-ajax.php", { method: "POST", body }).then(
        () => {},
      );
    }
  }
})();
